import { z } from 'zod';
import { ActionTypeSchema } from './actionTypes';
import { FormStateSchema } from '../formState';
import { NumericalIdSchema } from '../commonTypes';
export var updateFormStateActionSchema = z.object({
    type: ActionTypeSchema.extract(['UPDATE_FORM_STATE']),
    form_id: NumericalIdSchema.optional(),
    state: FormStateSchema,
    message: z.string().optional()
});
export var formStateActionsSchema = z.discriminatedUnion('type', [updateFormStateActionSchema]);
